import React from 'react';

var LobbyLoadingInfoWr = function (_a) {
    var children = _a.children, gameLogo = _a.gameLogo;
    return (React.createElement("div", { className: 'pgc-lobby-and-loading-logo-row' },
        React.createElement("img", { src: gameLogo, alt: 'game logo', className: 'pgc-common-logo' }),
        children));
};

export { LobbyLoadingInfoWr };
